<template>
    <div class="agent-and-loan-officer-home">
        <home-rounded-cover
            :src="cover"
            :headline="homeSection.headline"
            :sub-headline="homeSection.introduction"
            :actions="actions"
            :landing-page="landingPage"
        />

        <div class="cards-row d-flex align-items-center justify-content-center flex-column flex-sm-row">
            <agent-card
                :avatar="landingPageCardDetails.avatar"
                :display-name="landingPageCardDetails.displayName"
                :email="landingPageCardDetails.email"
                :company-logo="landingPageCardDetails.companyLogo"
                :phones="landingPageCardDetails.phones"
                :social-links="landingPageCardDetails.socialLinks"
                occupation="Real Estate Agent"
                class="align-self-stretch"
            />
            <hr class="break-line d-block d-sm-none">
            <agent-card
                :avatar="loanOfficerCardDetails.avatar"
                :display-name="loanOfficerCardDetails.displayName"
                :email="loanOfficerCardDetails.email"
                :company-logo="loanOfficerCardDetails.companyLogo"
                :phones="loanOfficerCardDetails.phones"
                :social-links="loanOfficerCardDetails.socialLinks"
                occupation="Loan Officer"
                class="align-self-stretch"
            />
        </div>
        <div class="info text-center mx-auto">
            <p>
                There are many real estate brokerage and mortgage lending options available. You are free to shop around
                to determine that you are receiving the best services and rates available. The information above is
                provided for your reference, without warranty of any kind.
            </p>
        </div>
    </div>
</template>

<script>
    import './AgentAndLoanOfficer.scss';
    import './AgentAndLoanOfficer.mobile.scss';
    import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import {HOME_IMAGES} from "../../../../../helpers/images";
    import HomeRoundedCover from "../../HomeRoundedCover/HomeRoundedCover";
    import orderBy from "lodash/orderBy";
    import AgentCard from "../../../AgentCard/AgentCard";
    import {DESTINED_TO as PHONE_DESTINED_TO}
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPagePhoneAppResource";
    import {DESTINED_TO as SOCIAL_LINK_DESTINED_TO}
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageSocialLinkAppResource";


    export default {
        name: "AgentAndLoanOfficer",
        components: {
            AgentCard,
            HomeRoundedCover,
        },
        mixins: [
            ShowNotificationMixin,
            IsMobileMixin,
        ],
        props: {
            landingPage: {
                type: LandingPageAppResource,
                default: () => {
                    return new LandingPageAppResource({});
                }
            }
        },
        data() {
            return {
                homeSection: this.landingPage.home,
                loanOfficer: this.landingPage.home.loanOfficer,
            };
        },
        computed: {
            cover() {
                return (this.homeSection.cover || {}).publicStorageUrl || HOME_IMAGES.AGENT_AND_LOAN_OFFICER_COVER;
            },
            actions() {
                const actions = this.landingPage.actions ? this.landingPage.actions.toArray() : [];
                return orderBy(actions, ['sort'], ['desc']);
            },
            landingPageCardDetails() {
                let details = {
                    avatar: this.landingPage.avatar,
                    displayName: this.landingPage.firstName + ' ' + this.landingPage.lastName,
                    email: this.landingPage.email,
                    companyLogo: (this.landingPage.organizationLogo || {}).publicStorageUrl || null,
                    phones: [],
                    socialLinks: [],
                };
                if (this.landingPage.phones) {
                    details.phones = this.landingPage.phones.toArray().filter(item => {
                        return item.destinedTo === PHONE_DESTINED_TO.REAL_ESTATE_AGENT;
                    });
                }
                if (this.landingPage.socialLinks) {
                    details.socialLinks = this.landingPage.socialLinks.toArray().filter(item => {
                        return item.destinedTo === SOCIAL_LINK_DESTINED_TO.REAL_ESTATE_AGENT;
                    });
                }
                return details;
            },
            loanOfficerCardDetails() {
                let details = {
                    avatar: this.loanOfficer.avatar,
                    displayName: this.loanOfficer.firstName + ' ' + this.loanOfficer.lastName,
                    email: this.loanOfficer.email,
                    companyLogo: (this.loanOfficer.organizationLogo || {}).publicStorageUrl || null,
                    phones: [],
                    socialLinks: [],
                };
                if (this.landingPage.phones) {
                    details.phones = this.landingPage.phones.toArray().filter(item => {
                        return item.destinedTo === PHONE_DESTINED_TO.LOAN_OFFICER;
                    });
                }
                if (this.landingPage.socialLinks) {
                    details.socialLinks = this.landingPage.socialLinks.toArray().filter(item => {
                        return item.destinedTo === SOCIAL_LINK_DESTINED_TO.LOAN_OFFICER;
                    });
                }
                return details;
            }
        },
    };
</script>
